import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter-chips',
  templateUrl: './filter-chips.component.html',
  styleUrls: ['./filter-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterChipsComponent {
  @Input()
  public set filterState(filterState: any) {
    this.chips = [];
    if (filterState && filterState !== [] && filterState !== {}) {
      this.mapStateToChips(filterState);
      this._filterState = filterState;
    }
  }

  @Output()
  public filterStateChange: EventEmitter<any> = new EventEmitter<any>();

  public _filterState: any;
  public chips: any[] = [];

  private mapStateToChips(filterState: any): void {
    Object.keys(filterState).forEach((filter: any) => {
      filterState[filter].forEach(value =>
        this.chips.push({
          name: this.filterNameOperator(filter, value),
          selected: true,
          key: filter,
          value: value
        })
      );
    });
  }

  private filterNameOperator(filter: any, value: any): any {
    return (filter === 'query') ? ('zoekopdracht: ' + value) : this.filterSalarisOperator(filter, value);
  }

  private filterSalarisOperator(filter: any, value: any): any {
    return (filter === 'salaris') ? ('salaris-ondergrens: ' + value) : (filter + ':' + value);
  }

  public handleRemoveFilter($event): void {
    const foundtItem = this._filterState[$event.key].find(item => $event.value === item);
    if (foundtItem) {
      const index = this._filterState[$event.key].indexOf(foundtItem);
      this._filterState[$event.key].splice(index, 1);
      Object.keys(this._filterState).forEach(property => {
        if (this._filterState[property].length === 0) {
          delete this._filterState[property];
        }
      });
      this.filterStateChange.emit(this._filterState);
    }
  }
}
